import { MonitorIndexPage } from "./index";
import { Options } from "vue-class-component";
import components from "../../components/component";
import { getColorFromUUID } from "@/utils";

@Options({
  components: components,
})
export class DemoMonitorIndexPage extends MonitorIndexPage {
  equipments: any = [];
  option: any = {
    equipment: 3,
    sensor: 6,
  };

  async created() {
    this.map = {
      center: [6.51223, 100.258],
      markerLatLng: [
        [6.51223, 100.258],
        [6.51223, 100.261],
        [6.51623, 100.258],
      ],
    };
    this.equipments = [
      {
        id: "1",
        name: "Dust Analyzer",
        additional: {
          latitude: 6.51223,
          longitude: 100.258,
        },
        sensors: [
          {
            id: 1,
            color: getColorFromUUID("1", 4, ""),
            name: "PM",
            unit: "mg/m3",
            alarm: true,
            message: "Exceeding",
            alarm_type: 77,
            alarm_created_at: "2025-01-12",
            value: "0.00",
            min_threshold: 0,
            max_threshold: 100,
          },
          {
            id: 2,
            color: getColorFromUUID("2", 4, ""),
            name: "02",
            unit: "mg/m3",
            alarm: true,
            message: null,
            alarm_type: null,
            alarm_created_at: null,
            value: "0.00",
            min_threshold: 0,
            max_threshold: 100,
          },
        ],
      },
      {
        id: "2",
        name: "Energy Meter",
        additional: {
          latitude: 6.51223,
          longitude: 100.261,
        },
        sensors: [
          {
            id: 3,
            color: getColorFromUUID("3", 4, ""),
            name: "Voltage",
            unit: "V",
            alarm: false,
            alarm_type: 0,
            alarm_created_at: "2025-01-12",
            value: "0.00",
            min_threshold: 0,
            max_threshold: 100,
          },
          {
            id: 6,
            color: getColorFromUUID("6", 4, ""),
            name: "Current",
            unit: "A",
            alarm: false,
            alarm_type: 0,
            alarm_created_at: "2025-01-12",
            value: "0.00",
            min_threshold: 0,
            max_threshold: 100,
          },
        ],
      },
      {
        id: "3",
        name: "Water Sensor",
        additional: {
          latitude: 6.51223,
          longitude: 100.258,
        },
        sensors: [
          {
            id: 4,
            color: getColorFromUUID("4", 4, ""),
            name: "Flow rate",
            unit: "L/s",
            alarm: true,
            message: "Exceeding",
            alarm_type: 0,
            alarm_created_at: "2025-01-12",
            value: "0.00",
            min_threshold: 0,
            max_threshold: 100,
          },
          {
            id: 5,
            color: getColorFromUUID("5", 4, ""),
            name: "Chlorine",
            unit: "mg/L",
            alarm: false,
            message: "Exceeding",
            alarm_type: 77,
            alarm_created_at: "2025-01-12",
            value: "0.00",
            min_threshold: 0,
            max_threshold: 100,
          },
        ],
      },
    ];
  }
}
